module.exports = new __parcel__URL__("report-deployment-frequency.48f7b022.svg").toString();